import React, { useCallback } from "react";
import { useAuth } from "../contexts/session";

export const useAuthorization = () => {
    const { userObj, isLoading } = useAuth();
    
    const checkAccessControl = useCallback((requirePermissions) => {
        if(userObj === false) {
            return [false , true];
        }

        if(!userObj) return [false, isLoading];

        return [(userObj.access_control_names?.includes("*") || userObj.access_control_names?.includes(requirePermissions)), isLoading];
    }, [userObj, isLoading]);

    return {checkAccessControl};
};